import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

function relicNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "relic", next, x, y });
}

// 第10期。レリックマスへの寄り道がルートの意味を作る。入次数は2まで、交差なし。
export const MAP_NODES_FOUNDATION: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["f1l", "f1m", "f1r"], x: 3, y: 0 }),
  f1l: caseNode("f1l", ["f2l"], 1, 1),
  f1m: caseNode("f1m", ["rest-f2m"], 3, 1),
  f1r: caseNode("f1r", ["e2r"], 5, 1),
  f2l: caseNode("f2l", ["f3a", "relic-f3b"], 1, 2),
  "rest-f2m": restNode("rest-f2m", ["f3c"], 3, 2),
  e2r: eventNode("e2r", ["f3d", "rest-f3e"], 5, 2),
  f3a: caseNode("f3a", ["f4a"], 0, 3),
  "relic-f3b": relicNode("relic-f3b", ["f4b"], 2, 3),
  f3c: caseNode("f3c", ["f4b", "f4c"], 3, 3),
  f3d: caseNode("f3d", ["f4c", "e4e"], 5, 3),
  "rest-f3e": restNode("rest-f3e", ["e4e"], 6, 3),
  f4a: caseNode("f4a", ["f6a"], 0, 4),
  f4b: caseNode("f4b", ["f5b", "rest-f5c"], 2, 4),
  f4c: caseNode("f4c", ["f5d"], 4, 4),
  e4e: eventNode("e4e", ["f5d"], 6, 4),
  f5b: caseNode("f5b", ["f6b"], 1, 5),
  "rest-f5c": restNode("rest-f5c", ["f6c"], 3, 5),
  f5d: caseNode("f5d", ["f6c", "relic-f6e"], 5, 5),
  f6a: caseNode("f6a", ["f7a"], 0, 6),
  f6b: caseNode("f6b", ["f7a", "f7b"], 2, 6),
  f6c: caseNode("f6c", ["f7b", "f7c"], 4, 6),
  "relic-f6e": relicNode("relic-f6e", ["f7c"], 6, 6),
  f7a: caseNode("f7a", ["f8a"], 0, 7),
  f7b: caseNode("f7b", ["f8a", "f8b"], 3, 7),
  f7c: caseNode("f7c", ["f8c"], 5, 7),
  f8a: caseNode("f8a", ["rest-f9l"], 1, 8),
  f8b: caseNode("f8b", ["rest-f9l"], 3, 8),
  f8c: caseNode("f8c", ["rest-f9r"], 5, 8),
  "rest-f9l": restNode("rest-f9l", ["boss"], 2, 9),
  "rest-f9r": restNode("rest-f9r", ["boss"], 4, 9),
  boss: node("boss", { kind: "case", caseId: "foundation-boss", next: [], x: 3, y: 10 }),
};
